module.exports = require('./lib/PublicServerAPI')



/** WEBPACK FOOTER **
 ** /Users/ryanflorence/Code/github/ryanflorence/react-project/server.js
 **/